/**
 * Resolve headline and optional body copy for digital-signature chat cards.
 * Title prefers message.title (e.g. PDF filename from bulk send), then attachment name.
 */
export function getDigitalSignatureCardTitle(message) {
  if (!message) return '';
  const attachmentName = message.attachments?.[0]?.name;
  return (message.title || attachmentName || message.text || '').trim();
}

export function getDigitalSignatureCardBody(message) {
  if (!message?.digitalSignature) return '';
  const title = getDigitalSignatureCardTitle(message);
  const text = (message.text || '').trim();
  if (!text || text === title) return '';
  return text;
}

/**
 * For digital-signature sends: optional employee copy lives in text; mirror title into
 * text when body is empty so pre-split mobile clients still show the card headline.
 */
export function resolveDigitalSignatureMessageText(title, text) {
  const trimmedTitle = (title || '').trim();
  const trimmedText = (text || '').trim();
  if (!trimmedText && trimmedTitle) {
    return trimmedTitle;
  }
  return trimmedText;
}
